<template>
  <PropertyDetailsCard>
    <template #title>
      <View as="span" gap="sm" align="center">
        Location
        <Badge v-if="isHiddenOnPlatforms" variant="grey" size="small" label="Hidden on platforms" />
      </View>
    </template>
    <template #action>
      <PropertyDetailsCardEditButton @click="showModal" />
    </template>
    <PropertyLocationInfo :property="property" />
    <PropertyLocationModal ref="locationModalRef" />
  </PropertyDetailsCard>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { Badge, View } from '@tallo/design-system';
import { usePropertyStore } from '@tallo/investor/property';
import { PropertyDetailsCard, PropertyDetailsCardEditButton, PropertyLocationInfo } from '@tallo/property';

import PropertyLocationModal from './property-location-modal.vue';

const locationModalRef = ref<InstanceType<typeof PropertyLocationModal>>();
const { property } = usePropertyStore();
const isHiddenOnPlatforms = computed(() => property?.location?.isAddressHidden);

function showModal() {
  locationModalRef.value?.modalRef?.show();
}
</script>
